<div
  *ngIf="trackedTime"
  class="add-tracked-time"
  [ngClass]="{ 'is-minimized': !isMinimized }"
  data-e2e-id="add-tracked-time"
>
  <header class="add-tracked-time-header">
    <button
      type="button"
      class="start-stop-timer"
      data-e2e-id="draft-tracked-time-start-stop-action"
      trackable
      [trackingObject]="popupObject"
      [trackingAction]="!timer ? startAction : stopAction"
      (click)="startStopTimer()"
    >
      <app-icon [icon]="!timer ? startIcon : stopIcon"></app-icon>
    </button>

    <button
      type="button"
      class="toggle-timer"
      trackable
      [trackingObject]="popupObject"
      [trackingAction]="isMinimized ? maximizeAction : minimizeAction"
      (click)="toggleTimer()"
    >
      <div class="toggle-timer-wrapper">
        <div class="timer-wrapper">
          <span class="timer-display">
            {{ timerDisplay }}
          </span>

          <span
            *ngIf="timerDescription"
            class="timer-description"
            [multiLineTruncate]="3"
          >
            {{ timerDescription }}
          </span>
        </div>

        <app-icon class="chevron-icon" [icon]="chevronDownIcon"> </app-icon>
      </div>
    </button>
  </header>

  <div *ngIf="!isMinimized" class="add-tracked-time-contents">
    <ng-container
      *ngIf="billing"
      [ngSwitch]="billing.hasValue() && !isClientEditMode"
    >
      <div *ngSwitchCase="true" class="billing-name-wrapper">
        <span class="billing-name-first-char">{{
          billing?.name && billing?.name.charAt(0) | capitalize
        }}</span>
        <span class="billing-name">{{ billing?.name }}</span>

        <button
          type="button"
          class="delete-action"
          trackable
          [trackingObject]="inputObject"
          [trackingAction]="deleteClientAction"
          (click)="deleteClient($event)"
        >
          <app-icon [icon]="removeIcon"></app-icon>
        </button>
      </div>

      <app-add-client
        *ngSwitchDefault
        class="add-client"
        [ngClass]="{ 'is-client-edit-mode': isClientEditMode }"
        [billing]="billing"
        [condensed]="true"
        [preventEditExistingClient]="true"
        [preventDeleteClient]="true"
        [secondaryAction]="'ACTION.CANCEL' | translate"
        [actionTriggers$]="addClientActionTriggers$"
        [documentSettings]="documentSettings$ | async"
        [accountSettings]="accountSettings$ | async"
        [featureToggles]="featureToggles$ | async"
        [locationInfo]="locationInfo$ | async"
        [trackingScreenName]="trackingScreenName"
        [trackingObject]="inputObject"
        [secondaryTrackingAction]="deleteClientAction"
        (onEditMode)="onClientEditMode($event)"
        (onUpdateClient)="updateClient($event)"
        (onNewClient)="saveClient($event)"
        (onSecondaryAction)="deleteClient()"
      >
      </app-add-client>

      <div *ngIf="errorMessage" class="error-message-wrapper">
        <app-icon class="error-icon" [icon]="errorIcon"> </app-icon>

        <span class="error-message">
          {{ errorMessage }}
        </span>
      </div>
    </ng-container>

    <div *ngIf="!isClientEditMode" class="tracked-time-form-wrapper">
      <app-textarea-field
        fieldId="notes_field"
        class="notes-field"
        textareaE2eId="draft-tracked-time-notes"
        [label]="'LABEL.NOTES' | translate"
        [condensed]="true"
        [placeholder]="'PLACEHOLDER.WHAT_ARE_YOU_WORKING_ON' | translate"
        [fieldControl]="form.get(formKeys.NOTES)"
        [maxlength]="2900"
        trackable
        [trackingObject]="popupObject"
        [trackingAction]="notesAction"
      >
      </app-textarea-field>

      <div class="form-actions">
        <button
          type="button"
          class="form-action save-action"
          data-e2e-id="draft-tracked-time-save-action"
          [disabled]="(trackedTime && !trackedTime.startDate) || timer"
          trackable
          [trackingObject]="popupObject"
          [trackingAction]="saveAction"
          (click)="saveTrackedTime()"
        >
          {{ 'ACTION.SAVE' | translate }}
        </button>

        <button
          type="button"
          class="form-action discard-action"
          data-e2e-id="draft-tracked-time-discard-action"
          trackable
          [trackingObject]="popupObject"
          [trackingAction]="discardAction"
          (click)="discardTrackedTime()"
        >
          {{ 'ACTION.DISCARD' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirm-dialog
  [dialogId]="discardConfirmationDialogId"
  [confirmTitle]="'TRACKED_TIME.DISCARD_TIME_DIALOG.TITLE' | translate"
  [confirmPrompt]="'TRACKED_TIME.DISCARD_TIME_DIALOG.PROMPT' | translate"
  [yesText]="'TRACKED_TIME.DISCARD_TIME_DIALOG.DISCARD' | translate"
  [cancelText]="'TRACKED_TIME.DISCARD_TIME_DIALOG.CANCEL' | translate"
  [isDeleteAction]="true"
  [trackingObject]="popupObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="discardTrackingAction"
  (onClose)="onDiscardConfirmClose($event)"
>
</app-confirm-dialog>
